









import Vue from 'vue'
import Component from 'vue-class-component'
import BaseIcon from '../components/BaseIcon.vue'
import ChevronCircle from '../components/icons/ChevronCircle.vue'

@Component<ArrowNavigation>({
  props: {
    backOnly: Boolean,
    forwardOnly: Boolean
  },
  watch: {
    backOnly(value) {
      if (value === true)
        this.showForwardButton = false;
      else
        this.showForwardButton = true;
    },
    forwardOnly(value) {
      if (value === true)
        this.showBackButton = false;
      else
        this.showBackButton = true;
    }
  },
  components: {
    BaseIcon,
    ChevronCircle
  }
})

export default class ArrowNavigation extends Vue {
  /**
   * Props variables
   */
  backOnly: boolean | undefined
  forwardOnly: boolean | undefined


  /**
   * Component state variables
   */
  showForwardButton = true
  showBackButton = true


  /**
   * Lifecycle
   */
  mounted() {
    if (this.backOnly === true) this.showForwardButton = false
    if (this.forwardOnly === true) this.showBackButton = false
  }


  /**
   * Getters
   */


  /**
   * Methods
   */
  changeSection (back?: boolean) {
    this.$emit('click', back)
  }

}
